//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { playCidVideo } from '@/util';
export default {
  name: 'Film',
  methods: {
    playCidVideo: playCidVideo
  }
};